import { Component, Optional } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { LanguageService } from 'src/app/services/account/language.service';
import { UtilsService } from 'src/app/services/utils/utils.service';
import device from 'current-device';
import { ModalOptionPanelComponent } from '../../modal-option-panel/modal-option-panel.component';

@Component({
  standalone: true,
  selector: 'app-privacy-policy',
  templateUrl: './privacy-policy.component.html',
  imports: [ModalOptionPanelComponent],
  styleUrls: ['./privacy-policy.component.scss']
})
export class PrivacyPolicyComponent {

  constructor(
    public languageService: LanguageService,
    private readonly utilsService: UtilsService,
    @Optional() public dialogRef: MatDialogRef<PrivacyPolicyComponent> | null
  ) { }

  openEuDataPolicy() {
    this.utilsService.openUrlOnNewTab(device, './assets/eu-data-policy.html');
  }
}
